import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs";
import { from } from "rxjs/observable/from";

import { AuthorizationService } from "./authorization.service";
import { environment } from "../../environments/environment";
import { GlobalFilterService } from "./global-filter.service";

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.handleAccessToken(req, next));
  }

  async handleAccessToken(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Promise<HttpEvent<any>> {
    const authorizationService = this.injector.get(AuthorizationService);

    const baseUrl = this.getBaseUrl(req.url);
    let audience = "";

    const isAuthZApiRequest =
      this.getBaseUrl(environment.authZApiRoot.url) === baseUrl;
    const isReconApiRequest =
      this.getBaseUrl(environment.reconApiRoot.url) === baseUrl;

    this.getBaseUrl(environment.authZApiRoot.url) === baseUrl;

    if (isAuthZApiRequest) {
      audience = environment.authZApiRoot.audience;
    }

    if (isReconApiRequest) {
      audience = environment.reconApiRoot.audience;
    }

    await authorizationService.waitUntilReady();

    let accessToken = "";

    if (authorizationService.HealthcareTopBar) {
      accessToken = await authorizationService.HealthcareTopBar.getAccessToken(
        audience
      );
    }

    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return next
      .handle(req)
      .do(
        (event: HttpEvent<any>) => {
          // globally do stuff with response if you want
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            try {
              const parsedError =
                typeof err.error === "string"
                  ? JSON.parse(err.error)
                  : err.error;

              if (
                parsedError &&
                parsedError.Content === "Environment Unavailable."
              ) {
                const gfs = this.injector.get(GlobalFilterService);
                // This causes the popup to display even after it has been dismissed.
                gfs.userDismissedUnavailableEnvironmentDialog = false;
                gfs.selectedEnvironmentIsAvailable = false;
              }
            } catch (e) {
              // swallow JSON parse errors
              console.error("Failed to parse 400 error body", e);
            }
          }
        }
      )
      .toPromise();
  }

  private getBaseUrl(url: string): string {
    try {
      const urlObj = new URL(url);
      return `${urlObj.protocol}//${urlObj.host}`;
    } catch (e) {
      console.error("getBaseUrl failed for:", url);
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/token-interceptor.service.ts